import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { fundRemainingBg, mcaI20Logo, mcaLogo, squadBg } from "../../Assets";
import { useAuthStore } from "../../store";
import { getTeamDetails } from "../../Utils/apiService";
import TeamSquadList from "./components/TeamSquadList";
import { formatToIndianCurrencyWords2 } from "../../Utils/helperFunctions";

const SquadList = () => {
  const [teamDetails, setTeamDetails] = useState<any>();
  const { teamDetailsTrigger, liveTeamId } = useAuthStore();
  console.log(liveTeamId, "liveTeamId");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [teamsRes] = await Promise.all([getTeamDetails()]);

        if (teamsRes?.data?.success) {
          setTeamDetails(teamsRes?.data?.data);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, [teamDetailsTrigger]);

  console.log(teamDetails, "teamDetails");

  const teamDetailsData = teamDetails?.find(
    (team: any) => team?.Id === liveTeamId
  );

  console.log(teamDetailsData, "teamDetailsDatasas");

  const renderInitialLogo = () => (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        background: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "4vw",
          // position: "absolute",
          marginBottom: "80px",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <img
          src={mcaI20Logo}
          style={{ height: "13vw", width: "auto" }}
          alt=""
        />
        <Typography sx={{ fontSize: "3.3vw", color: "#fff", fontWeight: 800 }}>
          T20 Mumbai League - 2025
        </Typography>
      </Box>
    </Box>
  );

  if (liveTeamId === null) {
    return renderInitialLogo();
  }

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          position: "relative",
          width: "100%",
          height: "fit-content",
        }}
      >
        <img
          src={squadBg}
          style={{ width: "100%", height: "100%", position: "absolute" }}
          alt="player team logo"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            paddingLeft: "4vw",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              position: "relative",
            }}
          >
            <img
              src={mcaLogo}
              style={{ height: "4vw", width: "auto", marginBottom: "1vw" }}
              alt="logo"
            />
            <Box
              sx={{
                height: "50%",
                width: ".5px",
                backgroundColor: "white",
                marginBottom: "1vw",
              }}
            ></Box>

            <img
              src={teamDetailsData?.Logo_URL__c}
              style={{ height: "4vw", width: "auto", marginBottom: "1vw" }}
              alt="logo"
            />
          </Box>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "85%",
            }}
          >
            <Box
              sx={{
                padding: "1.8vw 2vw",
                position: "relative",
                filter: "drop-shadow(0px 0px 84.35px #1768B1)",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 900,
                  color: "#fff",
                  fontSize: "1.8vw",
                  fontStyle: "italic",
                  marginBottom: "1vw",
                }}
              >
                SQUAD LIST
              </Typography>
            </Box>
            <Box
              sx={{
                position: "relative",
                marginBottom: "1vw",
                marginRight: "1vw",
              }}
            >
              <img
                src={fundRemainingBg}
                style={{ width: "100%", height: "100%", position: "absolute" }}
                alt="player team logo"
              />
              <Typography
                sx={{
                  position: "relative",
                  fontWeight: 700,
                  backgroundImage:
                    "radial-gradient(61.24% 43.3% at 50% 50%, #FFF200 0%, #FFF200 26%, #FBB040 97%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "1.5vw",
                  padding: "0.2vw 3vw",
                  fontStyle: "italic",
                  textTransform: "uppercase",
                }}
              >
                Fund remaining:{" "}
                <span style={{ fontWeight: 700, fontSize: "1.5vw" }}>
                  {formatToIndianCurrencyWords2(
                    teamDetailsData?.Fund_Remaining__c
                  )}
                </span>
              </Typography>
            </Box>
          </Box>
          <img
            src={mcaI20Logo}
            style={{
              height: "4vw",
              width: "auto",
              marginBottom: "1vw",
              position: "relative",
            }}
            alt="logo"
          />
        </Box>
      </Box>
      {/* <TeamSection teamDetails={teamDetails} /> */}
      <TeamSquadList
        teamDetailsData={teamDetailsData?.Player_Registrations__r?.records}
      />
      {/* <CustomTable teamDetails={teamDetails} /> */}
      <Typography variant="h1" color="white"></Typography>
    </Box>
  );
};

export default SquadList;
